import request from "@/utils/request";

export async function login(data) {
  return request({
    url: "/auth/login",
    method: "post",
    data,
  });
}

export function getUserInfo() {
  return request({
    url: "/auth/userInfo",
    method: "get",
  });
}

export function logout() {
  return request({
    url: "/auth/logout",
    method: "get",
  });
}
